export default __webpack_public_path__ + "static/media/marker-blue-gray.5e27b46a.png";